import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const PatientViewPage = lazy(() =>
  import("./pages/PatientViewPage").then((m) => ({ default: m.PatientViewPage }))
);
const PatientListPage = lazy(() => import("./pages/PatientListPage"));
const PatientNewPage = lazy(() => import("./pages/PatientNewPage"));
const PatientEditPage = lazy(() =>
  import("./pages/PatientEditPage").then((m) => ({ default: m.PatientEditPage }))
);

export const patientsRoutes: RouteObject[] = [
  {
    path: "",
    element: <PatientListPage />,
  },
  {
    path: ":id/view",
    element: <PatientViewPage />,
  },
  {
    path: ":id/edit",
    element: <PatientEditPage />,
  },
  {
    path: "new",
    element: <PatientNewPage />,
  },
];
